<template>
  <div class="admin-layout">
    <!-- 左侧导航栏 -->
    <div class="admin-sidebar">
      <div class="admin-logo" @click="goToHome">
        <span class="logo-text">MKCases</span>
      </div>
      <el-menu
        :default-active="activeMenu"
        class="admin-menu"
        router
        :collapse="false"
      >
        <el-menu-item index="/admin/dashboard" :route="{ name: 'AdminDashboard' }">
          <template #icon>
            <el-icon><House /></el-icon>
          </template>
          <span>概览</span>
        </el-menu-item>
        <el-menu-item index="/admin/news" :route="{ name: 'AdminNews' }">
          <template #icon>
            <el-icon><Document /></el-icon>
          </template>
          <span>新闻管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/market" :route="{ name: 'AdminMarket' }">
          <template #icon>
            <el-icon><ShoppingBag /></el-icon>
          </template>
          <span>市场管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/categories" :route="{ name: 'AdminCategories' }">
          <template #icon>
            <el-icon><Folder /></el-icon>
          </template>
          <span>分类管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/tags" :route="{ name: 'AdminTags' }">
          <template #icon>
            <el-icon><PriceTag /></el-icon>
          </template>
          <span>标签管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/tools" :route="{ name: 'AdminTools' }">
          <template #icon>
            <el-icon><Tools /></el-icon>
          </template>
          <span>工具管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/about" :route="{ name: 'AdminAbout' }">
          <template #icon>
            <el-icon><InfoFilled /></el-icon>
          </template>
          <span>关于管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/prompts" :route="{ name: 'AdminPrompts' }">
          <template #icon>
            <el-icon><ChatLineRound /></el-icon>
          </template>
          <span>提示词管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/agents" :route="{ name: 'AdminAgents' }">
          <template #icon>
            <el-icon><Robot /></el-icon>
          </template>
          <span>智能体管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/footer" :route="{ name: 'AdminFooter' }">
          <template #icon>
            <el-icon><Setting /></el-icon>
          </template>
          <span>页脚配置</span>
        </el-menu-item>
      </el-menu>
    </div>

    <!-- 右侧内容区 -->
    <div class="admin-content">
      <div class="admin-header">
        <div class="admin-title">{{ pageTitle }}</div>
        <div class="admin-actions">
          <el-button type="text" @click="logout">退出登录</el-button>
        </div>
      </div>
      <div class="admin-main">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { House, ShoppingBag, Tools, Document, InfoFilled, Setting, Folder, PriceTag, ChatLineRound, Robot } from '@element-plus/icons-vue'

export default {
  name: 'AdminLayout',
  components: {
    House,
    ShoppingBag,
    Tools,
    Document,
    InfoFilled,
    Setting,
    Folder,
    PriceTag,
    ChatLineRound,
    Robot
  },
  computed: {
    activeMenu() {
      return this.$route.path
    },
    pageTitle() {
      const titleMap = {
        '/admin/dashboard': '概览',
        '/admin/market': '市场管理',
        '/admin/categories': '分类管理',
        '/admin/tags': '标签管理',
        '/admin/tools': '工具管理',
        '/admin/news': '新闻管理',
        '/admin/about': '关于管理',
        '/admin/prompts': '提示词管理',
        '/admin/agents': '智能体管理',
        '/admin/footer': '页脚配置'
      }
      return titleMap[this.$route.path] || '管理后台'
    }
  },
  methods: {
    goToHome() {
      this.$router.push('/')
    },
    logout() {
      localStorage.removeItem('admin_token')
      this.$router.push('/admin/login')
    }
  }
}
</script>

<style scoped>
.admin-layout {
  display: flex;
  height: 100vh;
  background-color: #0a0a0a;
}

.admin-sidebar {
  width: 240px;
  background-color: rgba(15, 15, 25, 0.95);
  border-right: 1px solid rgba(0, 150, 255, 0.3);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  flex-shrink: 0;
}

.admin-logo {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid rgba(0, 150, 255, 0.3);
  cursor: pointer;
  transition: all 0.3s;
  padding: 0 20px;
}

.admin-logo:hover {
  background-color: rgba(0, 150, 255, 0.1);
}

.logo-text {
  font-size: 24px;
  font-weight: bold;
  color: #00d4ff;
  text-shadow: 0 0 10px rgba(0, 212, 255, 0.5);
  letter-spacing: 2px;
}

.admin-menu {
  flex: 1;
  border: none;
  background-color: transparent;
  padding: 10px 0;
}

.admin-menu .el-menu-item {
  height: 50px;
  line-height: 50px;
  color: rgba(255, 255, 255, 0.7);
  border-left: 3px solid transparent;
  margin: 5px 10px;
  border-radius: 4px;
  transition: all 0.3s;
}

.admin-menu .el-menu-item:hover {
  background-color: rgba(0, 150, 255, 0.15);
  color: #00d4ff;
  border-left-color: rgba(0, 212, 255, 0.5);
}

.admin-menu .el-menu-item.is-active {
  background-color: rgba(0, 150, 255, 0.2);
  color: #00d4ff;
  border-left-color: #00d4ff;
}

.admin-menu .el-menu-item [class*="el-icon"] {
  margin-right: 8px;
  font-size: 18px;
}

.admin-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: #0a0a0a;
}

.admin-header {
  height: 60px;
  background-color: rgba(15, 15, 25, 0.95);
  border-bottom: 1px solid rgba(0, 150, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  flex-shrink: 0;
}

.admin-title {
  font-size: 20px;
  font-weight: 500;
  color: #e0e0e0;
}

.admin-actions {
  display: flex;
  align-items: center;
  gap: 15px;
}

.admin-actions .el-button {
  color: rgba(255, 255, 255, 0.7) !important;
}

.admin-actions .el-button:hover {
  color: #00d4ff !important;
}

.admin-main {
  flex: 1;
  overflow-y: auto;
  padding: 30px;
  background-color: #0a0a0a;
}

/* 滚动条样式 */
.admin-sidebar::-webkit-scrollbar,
.admin-main::-webkit-scrollbar {
  width: 6px;
}

.admin-sidebar::-webkit-scrollbar-track,
.admin-main::-webkit-scrollbar-track {
  background: rgba(15, 15, 25, 0.5);
}

.admin-sidebar::-webkit-scrollbar-thumb,
.admin-main::-webkit-scrollbar-thumb {
  background: rgba(0, 150, 255, 0.3);
  border-radius: 3px;
}

.admin-sidebar::-webkit-scrollbar-thumb:hover,
.admin-main::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 150, 255, 0.5);
}
</style>

